// utils/toastErrors.js
import { toast } from "react-toastify";

const FIELD_TRANSLATIONS = {
  nom: "Nom",
  prenom: "Prénom",
  email: "E-mail",
  produit: "Produit",
  produits_associes: "Produits associés",
  quantite: "Quantité",
  prix: "Prix",
  dossier: "Dossier",
  intitule: "Intitulé",
  client: "Client",
  fournisseur: "Fournisseur",
  compte_comptable: "Compte comptable",
};

function formatErrorDetail(key, val) {
  // Ignorer les clés génériques d'erreur
  const displayKey = (key === "non_field_errors" || key === "message" || key === "detail" || key === "status") ? "" : (FIELD_TRANSLATIONS[key] || key);
  
  if (typeof val === "string") {
    return displayKey ? `${displayKey} : ${val}` : val;
  }
  
  if (Array.isArray(val)) {
    return val.map(item => formatErrorDetail(key, item)).filter(Boolean).join("\n");
  }
  
  if (typeof val === "object" && val !== null) {
    return Object.entries(val)
      .map(([subKey, subVal]) => {
        const nextKey = isNaN(subKey) ? subKey : key;
        return formatErrorDetail(nextKey, subVal);
      })
      .filter(Boolean)
      .join("\n");
  }
  
  return "";
}

export function toastApiErrors(error) {
  const data = error?.data;
  const message = data?.message || error?.message || data?.detail || error?.detail;
  const toasts = [];

  if (message) {
    const formatted = formatErrorDetail("message", message);
    if (formatted) toasts.push(...formatted.split("\n"));
  } else if (data && typeof data === "object" && !Array.isArray(data)) {
    // Erreurs de champ DRF : {"justificatif_file_id": "message", ...}
    Object.entries(data).forEach(([key, val]) => {
      const label = FIELD_TRANSLATIONS[key];
      const values = Array.isArray(val) ? val : [val];
      values.forEach((v) => {
        if (typeof v === "string") {
          toasts.push(label ? `${label} : ${v}` : v);
        } else {
          const formatted = formatErrorDetail(key, v);
          if (formatted) toasts.push(...formatted.split("\n"));
        }
      });
    });
  } else if (typeof data === "string") {
    toasts.push(data);
  }

  const clean = toasts.filter((t) => t && t.trim());
  if (!clean.length) {
    toast.error("Une erreur inattendue s'est produite.");
    return;
  }
  clean.forEach((t) => toast.error(t.trim()));
}